/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                var priceWidget = $('.price-widget');
                var priceContainer = priceWidget.find('.price-container');
                var price = priceContainer.find('.price');
                var priceText = price.find('span');
                var priceBar = priceContainer.find('.price-bar');
                var form = priceContainer.find('form');
                var min = parseInt(priceContainer[0].dataset.min);
                var max = parseInt(priceContainer[0].dataset.max);
                var defaultPrice = parseInt(priceContainer[0].dataset.default);
                var body = $(document).find('body');
                var moving = false;

                var setPrice = function (newPrice) {
                    newPrice = Math.max(newPrice, min);
                    newPrice = Math.min(newPrice, max);
                    var width = priceBar.width();
                    var x = width / (max - min) * (newPrice - min);
                    price.css('left', x + 'px');
                    priceText.text(newPrice);
                };

                // Initial position.
                setPrice(defaultPrice);
                price.css('opacity', '');

                // Mouse down
                var mouseDown = function (e) {
                    moving = true;
                    e.preventDefault();
                };
                price.on('mousedown touchstart', mouseDown);
                priceBar.on('mousedown touchstart', mouseDown);

                // Mouse move
                var mouseMove = function (e) {
                    if (!moving) {
                        return;
                    }

                    if (e.originalEvent && e.originalEvent.touches) {
                        e = e.originalEvent.touches[0];
                    }

                    // Reposition slider button.
                    var priceBarOffset = priceBar.offset();
                    var width = priceBar.width();
                    var x = e.pageX - priceBarOffset.left;
                    x = Math.max(x, 0);
                    x = Math.min(x, width);
                    price.css('left', x + 'px');

                    // Change price.
                    var number = Math.round(x / width * (max - min) + min);
                    if (number <= 3000) {
                        number = Math.round(number / 100) * 100;
                    } else if (number <= 6000) {
                        number = Math.round(number / 500) * 500;
                    } else {
                        number = Math.round(number / 1000) * 1000;
                    }
                    priceText.text(number);
                    form.find('._amount').val(number);
                };
                priceBar.on('mousemove touchmove', mouseMove);
                body.on('mousemove touchmove', mouseMove);

                // Mouse up
                body.on('mouseup touchend', function () {
                    moving = false;
                });

                // Increment
                priceWidget.find('.increment').on('click', function () {
                    var newPrice = parseInt(priceText.text()) + 500;
                    setPrice(newPrice);
                });

                // Decrement
                priceWidget.find('.decrement').on('click', function () {
                    var newPrice = parseInt(priceText.text()) - 500;
                    setPrice(newPrice);
                });

                // Submit
                $('.price-container-button').on('click', function () {
                    form.submit();
                    return false;
                });

                // Show hidden sticky footer after some scrolling.
                var previousScrollTop = $(window).scrollTop();
                var totalScroll = 0;
                $(window).on('scroll', function (e) {
                    var stickyBanner = $('._sticky-banner');
                    totalScroll += Math.abs($(window).scrollTop() - previousScrollTop);
                    previousScrollTop = $(window).scrollTop();
                    if (totalScroll > 500 && !stickyBanner.hasClass('_closed')) {
                        stickyBanner.removeClass('_hidden');
                    }
                });
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
